import menuJson from '../menuJson.json';

const userStore = {
  state: () => ({
    menuList: menuJson.menuList,
    isLogin: false,
    empNo: null,
    empNm: null,
    empMobile: null,
    empDiv: null,
    findIds: null,
    nicePhoneNumber: null,
    businessInfo: null,
    niceErrorMessage: null,
    loginDateTime: null,
    isSessionExpired: false,
    isFirstVisit: false,
    isUpdatePhoneNumber: false,
    isFindId: false,
    isPasswordChange: false,
    isWithdraw: false,
  }),

  getters: {
    getMenuList: state => state.menuList,
  },

  mutations: {
    login: (state, payload) => {
      state.isLogin = true;
      state.isSessionExpired = false;
      state.empNo = payload.id;
      state.empDiv = payload.division;
      state.empNm = payload.name;
      state.empMobile = payload.phoneNumber;
      state.businessInfo = payload.businessInfo;
      state.loginDateTime = new Date().getTime();
    },
    logout: state => {
      state.isLogin = false;
      state.isSessionExpired = true;
      state.empNo = null;
      state.empDiv = null;
      state.empNm = null;
      state.empMobile = null;
      state.businessInfo = null;
      state.menuList = menuJson.menuList;
      state.loginDateTime = null;
    },
    isSessionExpired: (state, payload) => {
      state.isSessionExpired = payload;
    },
    authMenuList: (state, payload) => {
      state.menuList = payload;
    },
    isFirstVisit: (state, payload) => {
      state.isFirstVisit = payload;
    },
    setNicePhoneNumber: (state, payload) => {
      state.nicePhoneNumber = payload.phoneNumber;
      state.niceErrorMessage = payload.niceErrorMessage;
    },
    isUpdatePhoneNumber: (state, payload) => {
      state.isUpdatePhoneNumber = payload;
    },
    isFindId: (state, payload) => {
      state.isFindId = payload.isAuth;
      state.findIds = payload.findIds;
    },
    isPasswordChange: (state, payload) => {
      state.isPasswordChange = payload;
    },
    findIds: (state, payload) => {
      state.findIds = payload;
    },
    isWithdraw: (state, payload) => {
      state.isWithdraw = payload;
    },
  },

  actions: {
    login: ({ commit }, payload) => {
      commit('login', payload);
    },
    logout: ({ commit }) => {
      commit('logout');
    },
    authMenuList: ({ commit }, payload) => {
      commit('authMenuList', payload);
    },
  },
};

export default userStore;
